// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8b59d38","455":"b895035a","644":"ebfdf29f"}[chunkId] + ".chunk.js";
};